import React from "react";
import clsx from "clsx";
import SeasonBuilderErrors from "../SeasonBuilderErrors";
import DateHelper from "../../DateHelper/DateHelper";
import DatePickerInput from '../../DatePickerInput/DatePickerInput';
import NumberInput from "../../NumberInput/NumberInput";
import HolidayCountrySelect from "../../Selects/HolidayCountrySelect";
import HolidayNameSelect from "../../Selects/HolidayNameSelect";
import { addDays, subDays, format } from 'date-fns';

class SeasonBuilderGeneral extends React.Component {

  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);
    this.onChangeStartDate = this.onChangeStartDate.bind(this);
    this.onChangeEndDate = this.onChangeEndDate.bind(this);
    this.onChangeHolidayName = this.onChangeHolidayName.bind(this);
    this.onChangeHolidayCountry = this.onChangeHolidayCountry.bind(this);
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.activeTab == 'general',
      'tab-pane': true
    });

    return (
      <div className={tabClasses} style={{ marginBottom: -18 }}>

        {SeasonBuilderErrors.renderGeneralErrors(this.props.errors)}

        <div className="row">
          <div className="col-md-3">
            <div className="form-group">
              <label>{`${I18n.t('code')}*`}</label>
              {
                this.props.read_only
                  ?
                  <div>{this.props.code}</div>
                  :
                  <input
                    type="text"
                    name="code"
                    value={this.props.code || ''}
                    className={this.renderFieldClasses('code')}
                    data-model="Season"
                    data-column="name"
                    onChange={this.onChange} />
              }
              {this.renderFieldErrors("code")}
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <label>{`${I18n.t('name')}*`}</label>
              {
                this.props.read_only
                  ?
                  <div>{this.props.name}</div>
                  :
                  <input
                    type="text"
                    name="name"
                    value={this.props.name || ''}
                    className={this.renderFieldClasses('name')}
                    data-model="Season"
                    data-column="name"
                    onChange={this.onChange} />
              }
              {this.renderFieldErrors("name")}
            </div>
          </div>

          <div className="col-md-3">
            <div className="form-group">
              <label>{I18n.t('status')}</label>
              {
                this.props.read_only
                  ?
                  <div>{I18n.t(this.props.status)}</div>
                  :
                  <select name="status" value={this.props.status || ''} className="form-control" onChange={this.onChange}>
                    <option value="disabled">{I18n.t('Disabled')}</option>
                    <option value="enabled">{I18n.t('enabled')}</option>
                  </select>
              }
            </div>
          </div>

          <div className="col-md-3">
            <div className="form-group">
              {
                this.props.read_only
                  ?
                  <div>{I18n.t(this.props.season_type)}</div>
                  :
                  <div >
                    <label>{I18n.t('season_type')} <span className="ss-help help" title={I18n.t('season_type_helper_text')}></span></label>
                    <select name="season_type" value={this.props.season_type} onChange={this.onChange} className="form-control">
                      <option value="exact_dates">{I18n.t('exact_dates')}</option>
                      <option value="holiday">{I18n.t('holiday')}</option>
                    </select>
                  </div>
              }
            </div>
          </div>
        </div>
        <br />
        <br />
        <div className="row">
          <div className="col-md-12">
            {this.props.season_type == 'exact_dates' ? this.renderExactDatesForm() : null}
            {this.props.season_type == 'holiday' ? this.renderHolidayForm() : null}

          </div>

        </div>

      </div>
    );
  }

  renderHolidayForm() {
    var years = this.props.all_years.map((year) => {
      return <option key={`${year}`}>{year}</option>
    })
    return (
      <div className="card" style={{ paddingBottom: 0, background: 'transparent', marginBottom: 15 }}>
        <h5 className="panel-heading-text">{I18n.t('holiday')}</h5>

        <div className="row">
          <div className="col-md-3">
            <div className="form-group">
              <label>{`${I18n.t('holiday_region')}* `}<span className="ss-help help" title={I18n.t('holiday_region_helper_text')}></span></label>
              {
                this.props.read_only
                  ?
                  <div>{this.props.holiday_region}</div>
                  :
                  <HolidayCountrySelect name="holiday_region" country={this.props.country} onChange={this.onChangeHolidayCountry} hasError={this.renderFieldClasses("holiday_region", true)} />
              }
              {this.renderFieldErrors("holiday_region")}
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <label>{`${I18n.t('holiday_year')}* `}</label>
              {
                this.props.read_only
                  ?
                  <div>{this.props.holiday_year}</div>
                  :
                  <select name="holiday-year" value={this.props.holiday_year} onChange={this.props.onChangeYear} className="form-control" ref="holiday_years" style={{width: '100%', minHeight: 33}}>
                    {years}
                  </select>
              }
              {this.renderFieldErrors("holiday_region")}
            </div>
          </div>

          <div className="col-md-6">
            <div className="form-group">
              <label>{`${I18n.t('holiday_name')}* `}<span className="ss-help help" title={I18n.t('holiday_name_helper_text')}></span></label>
              {
                this.props.read_only
                  ?
                  <div>{this.props.holiday_name}</div>
                  :
                  <HolidayNameSelect name="holiday_name" date_format={this.props.date_format} holiday_year={this.props.holiday_year} country={this.props.holiday_region} holiday={this.props.holiday} onChange={this.onChangeHolidayName} hasError={this.renderFieldClasses("holiday_name", true)} />
              }
              {this.renderFieldErrors("holiday_name")}
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-4">
            <div className="form-group">
              <label>{`${I18n.t('days_before')}* `} <span className="ss-help help" title={I18n.t('holiday_days_before_helper_text')}></span></label>
              {
                this.props.read_only
                  ?
                  <div>{this.props.holiday_days_before}</div>
                  :
                  <NumberInput
                    name="holiday_days_before"
                    value={this.props.holiday_days_before ? this.props.holiday_days_before : 0}
                    className={this.renderFieldClasses('holiday_days_before')}
                    onChange={this.onChange} />
              }
              {this.renderFieldErrors("holiday_days_before")}
            </div>
          </div>

          <div className="col-md-4">
            <div className="form-group">
              <label>{`${I18n.t('days_after')}* `}<span className="ss-help help" title={I18n.t('holiday_days_after_helper_text')}></span></label>
              {
                this.props.read_only
                  ?
                  <div>{this.props.holiday_days_after}</div>
                  :
                  <NumberInput
                    name="holiday_days_after"
                    value={this.props.holiday_days_after ? this.props.holiday_days_after : 0}
                    className={this.renderFieldClasses('holiday_days_after')}
                    onChange={this.onChange} />
              }
              {this.renderFieldErrors("holiday_days_after")}
            </div>
          </div>

        </div>
      </div>
    );
  }

  renderExactDatesForm() {
    return (
      <div className="card" style={{ paddingBottom: 0, background: 'transparent', marginBottom: 15 }}>
        <h5 className="panel-heading-text">{I18n.t('exact_dates')}</h5>

        <div className="row">
          <div className="col-md-4">
            <div className="form-group">
              <label>{`${I18n.t('begins')}*`} <span className="ss-help help" title={I18n.t('season_start_date_helper_text')}></span></label>
              {
                this.props.read_only
                  ?
                  <div>{format(new Date(this.props.exact_start_date), DateHelper.rubyToDateFNS(this.props.date_format))}</div>
                  :
                  <DatePickerInput
                    selectedDate={this.props.exact_start_date || ''}
                    dateFormat={DateHelper.rubyToDateFNS(this.props.date_format)}
                    onChange={this.onChangeStartDate}
                    hasError={this.renderFieldClasses("begins", true)} />
              }
              {this.renderFieldErrors("begins")}
            </div>
          </div>

          <div className="col-md-4">
            <div className="form-group">
              <label>{`${I18n.t('ends')}*`} <span className="ss-help help" title={I18n.t('season_end_date_helper_text')}></span></label>
              {
                this.props.read_only
                  ?
                  <div>{format(new Date(this.props.exact_end_date), DateHelper.rubyToDateFNS(this.props.date_format))}</div>
                  :
                  <DatePickerInput
                    selectedDate={this.props.exact_end_date || ''}
                    dateFormat={DateHelper.rubyToDateFNS(this.props.date_format)}
                    onChange={this.onChangeEndDate}
                    hasError={this.renderFieldClasses("ends", true)} />
              }
              {this.renderFieldErrors("ends")}
            </div>
          </div>
        </div>

      </div>
    );
  }

  renderFieldClasses(field, noFormControl) {
    if (noFormControl === true) {
      var classname = ''
    } else {
      var classname = 'form-control';
    }
    if (this.props.errors && Object.keys(this.props.errors).length && this.props.errors[field]) {
      classname = classname + ' has-errors';
    }
    return classname;
  }

  renderFieldErrors(field) {
    
    if (this.props.errors && this.props.errors[field]) {
      var idx = 0;
      var errors = this.props.errors[field].map((error) => {
        idx = idx + 1;
        return <li key={idx}><b>&#x2022;</b>{error}</li>;
      });
      return (
        <div className="help-block">
          <ul>{errors}</ul>
        </div>
      )
    }
  }

  /******************
  * Change handlers *
  *******************/

  onChange(event) {
    if (typeof this.props.onChange == 'function') {
      this.props.onChange(event);
    }
  }

  onChangeStartDate(startDate) {
    if (this.props.exact_end_date <= startDate) {
      this.onChange({
        target: {
          name: 'exact_start_date',
          value: startDate,
        }
      });
      if (this.props.exact_end_date && startDate) {
        this.onChange({
          target: {
            name: 'exact_end_date',
            // value: addDays(new Date(startDate), 1),
            value: startDate
          }
        });
      }
    } else {
      this.onChange({
        target: {
          name: 'exact_start_date',
          value: startDate,
        }
      });
    }
  }

  onChangeEndDate(endDate) {
    if (this.props.exact_start_date >= endDate) {
      if (this.props.exact_start_date && endDate) {
        this.onChange({
          target: {
            name: 'exact_start_date',
            // value: subDays(new Date(endDate), 1),
            value: endDate,
          }
        });
      }
      this.onChange({
        target: {
          name: 'exact_end_date',
          value: endDate,
        }
      });
    } else {
      this.onChange({
        target: {
          name: 'exact_end_date',
          value: endDate,
        }
      });
    }
  }

  onChangeHolidayCountry(country) {
    if (typeof this.props.onChange == 'function') {
      this.props.onChange({
        target: {
          name: 'country',
          value: country
        }
      });
      this.props.onChange({
        target: {
          name: 'holiday_region',
          value: country.gec
        }
      })
    }
  }

  onChangeHolidayName(name) {
    if (typeof this.props.onChange == 'function') {
      this.props.onChange({
        target: {
          name: 'holiday_name',
          value: name.name
        }
      })
    }
  }

};

export default SeasonBuilderGeneral
